<div #tableContainer class="table-container mt-2" [ngClass]="{'min-h-11':!hideSearch}" (scroll)="onScroll($event)">
  <table class="table table-striped table-hover" [ngClass]="{'head-fixed':headerFixed, 'header-white':headerWhite}"
    *ngIf="!listView; else listViewTemplate">
    <thead>
      <tr class="table-head" [ngClass]="{'hide-search':hideSearch}">
        <th class="text-center align-bottom" style="width: 18px;padding: 2px 1px !important">
          <i class="bi bi-file-earmark-spreadsheet-fill cursor text-success" *ngIf="excel"
            ngbTooltip="{{'export_to_excel' |translate}}" (click)="exportExcel()" container="body"></i>

          <i class="bi bi-x-circle-fill cursor" ngbTooltip="{{'cancel_filters' |translate}}" (click)="cancelFilters()"
            container="body"></i>
          <input *ngIf="allowCheckboxed" class="form-control my-checkbox mx-auto" type="checkbox"
            [(ngModel)]="allChecked" (ngModelChange)="checkAllRows($event)" />
        </th>
        <th *ngFor="let col of cols; let i = index" class="align-bottom">
          <div class="d-flex align-items-center"
            [class]="{'cursor':(!col.noSearch || col.showSort), 'text-nowrap': col.noWrap}" scope="col"
            [sortable]="(col.noSearch && !col.showSort) ? null : col.attr" (sort)="onSort($event)">
            <div *ngIf="sortsMap[col.attr]">
              <i class="bi bi-arrow-up" *ngIf="sortsMap[col.attr] =='ASC'"></i>
              <i class="bi bi-arrow-down" *ngIf="sortsMap[col.attr] =='DESC'"></i>
            </div>
            {{'cols.'+col.attr|translate}}
          </div>
          <div [ngSwitch]="col.searchType || col.type" class="search-input w-100" [class]="col.thClass"
            *ngIf="!col.noSearch;else fakeSearch" [ngClass]="{'searching': search[col.searchAttr] != null}">
            <input *ngSwitchCase="'number'" class="form-control" type="number" [(ngModel)]="search[col.searchAttr]"
              (keyup.enter)="refresh()" (blur)="refresh()" [disabled]="col.disabled" />
            <select *ngSwitchCase="'bool'" class="form-control w-auto" [(ngModel)]="search[col.searchAttr]"
              (ngModelChange)="refresh()" [disabled]="col.disabled">
              <option [ngValue]="null">---</option>
              <option [ngValue]="1">{{'bool_1' | translate}}</option>
              <option [ngValue]="0">{{'bool_0' | translate}}</option>
            </select>
            <!-- <input *ngSwitchCase="'date'" class="form-control" type="date" [(ngModel)]="search[col.searchAttr]"
                (keyup.enter)="refresh()" (blur)="refresh()" [disabled]="col.disabled" />
              <input *ngSwitchCase="'datetime'" class="form-control" type="date" [(ngModel)]="search[col.searchAttr]"
                (keyup.enter)="refresh()" (blur)="refresh()" [disabled]="col.disabled" /> -->
            <ng-container *ngSwitchCase="'date'">
              <ng-container
                *ngTemplateOutlet="dateRangeDropdown; context: { attr: col.attr, disabled: col.disabled, onRight:i > (cols.length / 2) }">
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'datetime'">
              <ng-container
                *ngTemplateOutlet="dateRangeDropdown; context: { attr: col.attr, disabled: col.disabled, onRight:i > (cols.length / 2) }">
              </ng-container>
            </ng-container>
            <select *ngSwitchCase="'select'" class="form-control w-auto" [class]="col.thClass"
              [(ngModel)]="search[col.searchAttr]" (ngModelChange)="refresh()">
              <option [ngValue]="null">---</option>
              <option [ngValue]="opt.value" *ngFor="let opt of col.options">{{opt.text | translate}}</option>
            </select>
            <s-select *ngSwitchCase="'multi-select'" customClass="form-control-sm w-auto s-select-table"
              [(model)]="search[col.searchAttr]" (modelChange)="refresh()" [items]="col.options" appendTo="body"
              [multiple]="true" [bindLabel]="col.bindLabel" [bindValue]="col.bindValue" translateAppendix=".">
            </s-select>
            <input *ngSwitchDefault class="form-control" type="text" [(ngModel)]="search[col.searchAttr]"
              (keyup.enter)="refresh()" (blur)="refresh()" [disabled]="col.disabled" />
          </div>
          <ng-template #fakeSearch>
            <div class="fake-search border border-white">&nbsp;</div>
          </ng-template>
        </th>
        <ng-container *ngIf="slotTh" [ngTemplateOutlet]="slotTh">
        </ng-container>
      </tr>
      <tr *ngIf="sums || avgs">
        <th></th>
        <th *ngFor="let col of cols" class="font-08 text-end">
          <span *ngIf="sums[col.attr] || sums[col.attr] == 0" class="text-nowrap">
            <span class="font-07" style="vertical-align: top;">&sum;</span>
            {{sums[col.attr]}}
          </span>
          <span *ngIf="avgs[col.attr]" class="text-nowrap">
            <span style="vertical-align: top;">&empty;</span>
            {{avgs[col.attr]}}
          </span>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="refreshUrl || staticRows; else noRefreshUrl">
      <ng-container *ngFor="let row of rows; let i = index">
        <tr [ngClass]="rowStaticClass" [class]="row.trClass" (click)="selectRow(i, $event)" *ngIf="!hideRows">
          <td>
            <input *ngIf="allowCheckboxed" class="form-control my-checkbox" type="checkbox" [(ngModel)]="row.checked" />
          </td>
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col.noTdTag" [class]="getTdClasses(col,row)">{{row[col.attr]}}</td>
          </ng-container>
          <ng-container *ngIf="slotTd" [ngTemplateOutlet]="slotTd"
            [ngTemplateOutletContext]="{$implicit:row, raw:rowsOrig[i], index:i}">
          </ng-container>
        </tr>
        <ng-container *ngIf="slotRow" [ngTemplateOutlet]="slotRow"
          [ngTemplateOutletContext]="{$implicit:row, raw:rowsOrig[i], index:i}">
        </ng-container>
      </ng-container>
      <tr *ngIf="rows && rows.length == 0 && !quietLoading">
        <td [attr.colspan]="cols.length+1" class="text-center fw-bolder">
          {{noRowsText |translate}}
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="quietLoading">
      <tr>
        <td [attr.colspan]="cols.length+1" class="text-center">
          <div class="spinner-border text-danger" role="status"></div>
        </td>
      </tr>
    </tbody>

    <ng-template #noRefreshUrl>
      <tbody>
        <tr>
          <td [attr.colspan]="cols.length+1" class="text-center fw-bolder">
            {{'disabled' |translate}}
          </td>
        </tr>
      </tbody>
    </ng-template>
  </table>

  <ng-template #dateRangeDropdown let-attr="attr" let-disabled="disabled" let-onRight="onRight">
    <div ngbDropdown #dateDropdown="ngbDropdown" class="w-100" autoClose="outside"
      [placement]="onRight ? 'bottom-right':'bottom-left'" (openChange)="onDropdownDate($event, attr)"
      [ngClass]="{'searching': search[attr] != null}">
      <button type="button" class="btn btn-outline-secondary btn-sm w-100 btn-toggle-date" ngbDropdownToggle
        [disabled]="disabled">
        {{ formatDateRange(search[attr]) || '&nbsp;' }}
      </button>
      <div ngbDropdownMenu class="p-2 border shadow-sm bg-white">
        <div *ngIf="dateRangeTmp">
          <input type="date" class="form-control mb-2" [(ngModel)]="dateRangeTmp.from">

          <input type="date" class="form-control mb-2" [(ngModel)]="dateRangeTmp.to">

          <div class="d-flex justify-content-between border-bottom">
            <button class="btn btn-sm py-0 px-3 btn-outline-secondary me-2"
              (click)="clearDateRange(attr);dateDropdown.close()">
              <i class="bi bi-x-circle"></i>
            </button>
            <button class="btn btn-sm py-0 px-3 btn-secondary" (click)="applyDateRange(attr);dateDropdown.close()">
              <i class="bi bi-search"></i>
            </button>
          </div>
          <!-- <div *ngFor="let btn of dateIntervalBtns" class="btn btn-sm btn-outline-secondary" (click)="selectDateInterval(btn,attr)">
            {{('date.'+btn)|translate}}
          </div> -->
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #listViewTemplate>
    <div class="input-group w-auto mb-1" *ngIf="mobileSearchAttr">
      <div class="input-group-prepend input-group-text bg-secondary">
        <i class="bi bi-search"></i>
      </div>
      <input type="text" class="form-control w-auto" placeholder="{{'search'|translate}}"
        [(ngModel)]="search[mobileSearchAttr]" (keyup.enter)="refresh()" (blur)="refresh()" name="filterMobile">
    </div>
    <div class="card w-100 d-flex flex-wrap mb-1" *ngFor="let row of rows; let i = index" [class]="row.trClass">
      <div class="card-body d-flex flex-wrap" (click)="selectRow(i, $event)">
        <ng-container *ngIf="!slotDiv; else showSlotDiv">
          <div *ngFor="let div of mobileDivs" [class]="div.class">
            <span class="me-1" *ngIf="div.showCol">{{('cols.'+div.attr)|translate}}:</span>
            {{row[div.attr]}}
            <span *ngIf="div.text">{{div.text}}</span>
          </div>
        </ng-container>
        <ng-template #showSlotDiv>
          <ng-container [ngTemplateOutlet]="slotDiv"
            [ngTemplateOutletContext]="{$implicit:row, raw:rowsOrig[i], index:i}">
          </ng-container>
        </ng-template>
      </div>
    </div>
    <div class="card w-100 d-flex flex-wrap" *ngIf="rows && rows.length == 0 && !quietLoading">
      <div class="card-body">
        <div class="text-center fw-bolder">
          {{'no_rows_found' |translate}}
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div #paginatorContainer class="d-flex flex-wrap justify-content-between align-items-center p-2 paginator-wrap"
  *ngIf="!hidePaginator && !shared.loading && rows && rows.length > 0">
  <ngb-pagination [collectionSize]="paginator.totalRows" [(page)]="paginator.page" [pageSize]="paginator.pageSize"
    (pageChange)="refresh()" [size]="paginatorSize" [maxSize]="paginatorMaxPages">
  </ngb-pagination>

  <div class="ms-1 me-auto" *ngIf="showLoop">
    <button class="btn btn-sm btn-secondary" ngbTooltip="{{'loop_over_pages'|translate}}" (click)="paginatorLoop(true)"
      type="button">
      <i class="bi bi-arrow-repeat" *ngIf="!paginator.loop; else loopDiv"></i>
      <ng-template #loopDiv>
        <i class="bi bi-slash-circle"></i>
        {{loopTime-loopCounter}}
      </ng-template>
    </button>
  </div>
  <span class="ms-1 me-auto text-dark d-none d-lg-block" *ngIf="refreshCounter">
    {{'Auto-refresh in'|translate}}&#32;{{refreshCounter}}&#32;{{'sec'|translate}}
  </span>
  <div class="text-secondary d-none d-lg-block" *ngIf="showCount">
    {{this.paginator.totalRows}}&#32;{{'items'|translate}}</div>


  <select class="form-control form-control-sm w-auto" name="pageSize" [(ngModel)]="paginator.pageSize"
    (ngModelChange)="paginator.page = 1;refresh()" *ngIf="showPageSize">
    <option [ngValue]="value" *ngFor="let value of itemsPerPageOptions">{{value}} {{'items_per_page'|translate}}
    </option>
  </select>

</div>
